import axios from 'axios';
import { getApiHeader } from './../services/getApiHeaders';

export function getListItemName(payload) {
    const options = {
        method: 'POST',
        url: process.env.REACT_APP_URL + '/api/itemname/search',
        withCredentials: true,
        headers: getApiHeader(),
        data: payload,
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/getListItemName.js